import DB_PATH from "../DB_PATH";
import { firestore } from "../firebase";

export const deleteShop = async (communityId: string): Promise<void> => {
  if (!communityId) return;

  const shopRef = firestore
    .collection(DB_PATH.COMMUNITY)
    .doc(communityId)
    .collection("Shop")
    .doc("shop");

  // Rethrow. A rejected write here is almost always a rules denial, and
  // swallowing it made the coach's edit vanish with a success message.
  try {
    await shopRef.delete();
  } catch (error) {
    console.error("Error deleting shop", error);
    throw error;
  }
};
